import React from 'react';
// import {createStyles, makeStyles} from '@material-ui/core';
import {
  APP,
  DEFAULT_BLACK_COLOR,
  DEFAULT_WHITE_COLOR
} from 'src/style/variable';
import {useTranslation} from 'react-i18next';
import {Options} from 'material-table';
import GridTable, {
  DEFAULT_GRID_TABLE__OPTIONS
} from '@components/system/GridTable/GridTable';

interface invoiceImportErrorTableProps {
  invoices: Array<any>;
  clinicName: string;
  clinicId: string | number;
}

const ImportInvoiceErrorTable = (
  props: invoiceImportErrorTableProps
): React.ReactElement => {
  const {invoices, clinicName, clinicId} = props;
  const {t} = useTranslation();
  // const classes = useStyles();
  const tableRef: any = React.useRef();

  const resetPagesInGrid = (): void => {
    if (
      tableRef.current?.onQueryChange &&
      typeof tableRef.current.onQueryChange === 'function'
    ) {
      tableRef.current.onQueryChange({page: 0});
    }
  };
  React.useEffect(() => {
    resetPagesInGrid();
  }, [invoices]);
  const tableColumns = [
    {
      title: t('PATIENTS.PATIENT_NAME'),
      field: 'org_group_id',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      },
      render: (row: any) => {
        let fullName = '';
        if (row.first_name) {
          fullName += row.first_name;
        }
        if (row.last_name) {
          fullName += fullName ? ` ${row.last_name}` : row.last_name;
        }
        return fullName;
      }
    },
    {
      title: t('PATIENTS.ACCOUNT_NUMBER'),
      field: 'account_no',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      }
    },
    {
      title: t('PATIENTS.STATEMENT_DATE'),
      field: '',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      },
      render: (row: any) => {
        return row.invoice_date ?? '';
      }
    },
    {
      title: t('PATIENTS.SERVICE_DATE'),
      field: '',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      },
      render: (row: any) => {
        return row.service_date ?? '';
      }
    },
    {
      title: t('PATIENTS.CLINICS'),
      field: 'clinic_name',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      },
      render: () => {
        return clinicName;
      }
    },
    {
      title: t('PATIENTS.ERROR'),
      field: 'error',
      headerStyle: {
        color: DEFAULT_BLACK_COLOR,
        backgroundColor: DEFAULT_WHITE_COLOR,
        fontFamily: APP.FONT_FAMILY.MEDIUM,
        fontSize: '1rem'
      },
      cellStyle: {
        fontFamily: APP.FONT_FAMILY.REGULAR
      }
    }
  ];

  const options: Options<any> = {
    ...DEFAULT_GRID_TABLE__OPTIONS,
    paging: invoices?.length > 0,
    emptyRowsWhenPaging: false,
    sorting: true,
    pageSize: 50,
    pageSizeOptions: [50],
    showEmptyDataSourceMessage: true,
    maxBodyHeight: '100%',
    actionsColumnIndex: -1,
    tableLayout: 'auto',
    detailPanelColumnAlignment: 'right',
    // selection: request,
    draggable: false,
    // showSelectAllCheckbox: request,
    headerStyle: {
      color: DEFAULT_BLACK_COLOR,
      fontFamily: APP.FONT_FAMILY.MEDIUM,
      flexDirection: 'row',
      zIndex: 100
    }
  };
  return (
    <GridTable
      localization={{
        body: {
          emptyDataSourceMessage: clinicId
            ? t('DUE_INVOICES.NO_FAILED_RECORDS')
            : t('DUE_INVOICES.SELECT_A_CLINIC')
        }
      }}
      // isLoading={loading}
      tableRef={tableRef}
      data={query => {
        return new Promise((resolve, reject) => {
          const data = invoices ?? [];
          const offset = query.page * query.pageSize;
          const limit = query.pageSize + offset;
          resolve({
            data: data.slice(offset, limit),
            page: query.page,
            totalCount: data.length
          });
        });
      }}
      columns={tableColumns}
      options={options}
      style={{
        margin: '0rem 2rem 5rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        boxShadow:
          '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)'
      }}
    />
  );
};

export default ImportInvoiceErrorTable;
